export default __webpack_public_path__ + "static/media/check-green.4e055a2c.svg";